import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Schriftstellerei = () => (
  <div className="breadcrumbs">

    <Helmet>
    <title>Творчество - Сергей Мавроди: Стихи, Проза, Дневники, Песни, …</title>
    <meta
      name="description"
      content="Творчество Сергея Мавроди: стихи, проза ('Сын Люцифера', 'Дневники', 'Неделька'), киносценарии, песни и рассказы о тюрьме."
    />
    <meta name="keywords" content="Сергей Мавроди, творчество, стихи, Сын Люцифера, дневники, киносценарии, песни, тюрьма, Неделька" />
    <meta name="author" content="Сергей Мавроди" />
    <meta property="og:title" content="Творчество - Сергей Мавроди" />
    <meta
      property="og:description"
      content="Литературное творчество Сергея Мавроди: стихи, 'Сын Люцифера', 'Дневники', киносценарии, песни, 'Неделька' и рассказы о тюрьме."
    />
    <meta property="og:image" content="https://www.sergey-mavrodi.com/images/portrait.webp" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:url" content="https://www.sergey-mavrodi.com/schriftstellerei" />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="ru_RU" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Творчество - Сергей Мавроди" />
    <meta
      name="twitter:description"
      content="Литературное творчество Сергея Мавроди: стихи, 'Сын Люцифера', 'Дневники', киносценарии, песни, 'Неделька' и рассказы о тюрьме."
    />
    <meta name="twitter:image" content="https://www.sergey-mavrodi.com/images/portrait.webp" />
    <link rel="canonical" href="https://www.sergey-mavrodi.com/schriftstellerei" />
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'Творчество',
        'description': 'Раздел творчества Сергея Мавроди: стихи, проза ("Сын Люцифера", "Дневники", "Неделька"), киносценарии, песни и рассказы о тюрьме.',
        'url': 'https://www.sergey-mavrodi.com/schriftstellerei',
        'image': 'https://www.sergey-mavrodi.com/images/portrait.webp',
        'publisher': {
          '@type': 'Organization',
          'name': 'Сергей Мавроди',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            {
              '@type': 'ListItem',
              'position': 1,
              'name': 'Главная',
              'item': 'https://www.sergey-mavrodi.com/',
            },
            {
              '@type': 'ListItem',
              'position': 2,
              'name': 'Творчество',
              'item': 'https://www.sergey-mavrodi.com/schriftstellerei',
            },
          ],
        },
      })}
    </script>
  </Helmet>

    <div className="breadcrumb">
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → Творчество
      </div>
    </div>
    <div className="content">
      <div className="content_white_cloud">
        <div className="cwc_top"></div>
        <div className="cwc_mid">
          <div className="content">
            <h2>ТВОРЧЕСТВО</h2>
           
           
            <div style={{ backgroundColor: 'rgb(220, 220, 220)', textAlign: 'center' }}>
            <p>&nbsp;</p>
            <div style={{ backgroundColor: 'white', marginLeft: '30px', marginRight: '30px' }}>

            <p style={{ margin: '0 0 0 0' }}>&nbsp;</p>

<div style={{ backgroundColor: 'rgb(243, 243, 243)', marginLeft: '20px', marginRight: '20px' }}>

<strong><Link to="/schriftstellerei/gedichte" className="yellow-underline" style={{ fontSize: '33px' }}>Мои стихи</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>Сын Люцифера</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/tagebucher" className="yellow-underline" style={{ fontSize: '33px' }}>Дневники Сына Люцифера</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/drehbuch" className="yellow-underline" style={{ fontSize: '33px' }}>Киносценарии</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/gefangnis" className="yellow-underline" style={{ fontSize: '33px' }}>Тюрьма</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/lieder" className="yellow-underline" style={{ fontSize: '33px' }}>Песни</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/woche" className="yellow-underline" style={{ fontSize: '33px' }}>Неделька</Link></strong>

</div>

<p>&nbsp;</p>
</div>
<p>&nbsp;</p>
</div> 
          </div>
        </div>
        <div className="cwc_bot"></div>
      </div>
    </div>
  </div>
);

export default Schriftstellerei;
